
import { Injectable } from '@angular/core';
import { FormGroup, FormControl} from '@angular/forms';
import { CustomerArcadeCodeService } from '../../../dms/modulos/general/componentes/gestion-terceros/servicios/customer-arcade-code.service';

@Injectable()
export class TablaSearchService {
  isLoading = false;
  showBoxResults = false;
  boxResults = false;

  formInvoices: FormGroup;
  public dataBoxResults: any[] = [];
  filaAnadida: boolean = false;
   customer: object;
  constructor(
     private _customerArcadeCodeService: CustomerArcadeCodeService
  ) {
    this.formInvoices = new FormGroup({
        searchCustomerCode: new FormControl(''),
        searchCustomerName: new FormControl(''),
        });
  }

  //Servicio de busqueda
  searchBoxResults(obj) {
    this.isLoading = true;
     this._customerArcadeCodeService.post<any[]>(JSON.stringify(obj)).subscribe(resp => {
        this.dataBoxResults = resp;
        this.isLoading = false;
      },
      error => {
        this.isLoading = false;
      }
    );
  }



  setCodeArcade(codeArcade: any) {

    this.formInvoices.get('searchCustomerCode').setValue(codeArcade.dataItem.LinkedCode, {emitEvent: false});
    this.formInvoices.get('searchCustomerName').setValue(codeArcade.dataItem.CompanyName, {emitEvent: false});
    // this.formInvoices.get('searchCustomerCodeFormat').setValue(customer.AccountingCode, {emitEvent: false});

    this.boxResults = false;
  }

}
